import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconPauseCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.44446 8.44444C8.44446 8.19898 8.64344 8 8.8889 8H10.6667C10.9121 8 11.1111 8.19898 11.1111 8.44444V15.5556C11.1111 15.801 10.9121 16 10.6667 16H8.8889C8.64344 16 8.44446 15.801 8.44446 15.5556V8.44444Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8889 8.44444C12.8889 8.19898 13.0879 8 13.3334 8H15.1111C15.3566 8 15.5556 8.19898 15.5556 8.44444V15.5556C15.5556 15.801 15.3566 16 15.1111 16H13.3334C13.0879 16 12.8889 15.801 12.8889 15.5556V8.44444Z",
			fill: "white"
		})
	]
});
export default SvgIconPauseCircle;
